import { CrewChangeRequestMoveType, CrewMember } from '@bechtel/types';

export interface CraftListProps {
  superintendent?: CrewMember;
  generalForeman?: CrewMember;
  foreman: CrewMember;
  selectedCrafts: CrewMember[];
  onCraftSelect: (crafts: CrewMember[]) => void;
  crewChangeRequestMoveType: CrewChangeRequestMoveType;
  onCraftDataLoaded: (hasAnyPendingRequest: boolean) => void;
}
